import { atom } from 'jotai';

export interface SnackbarState {
  open: boolean;
  text: string;
  type: 'success' | 'warning' | 'info' | 'error';
}

export const snackbarAtom = atom<SnackbarState>({
  open: false,
  text: '',
  type: 'info',
});

export const showSnackbarAtom = atom(
  null,
  (_, set, update: Omit<SnackbarState, 'open'>) => {
    set(snackbarAtom, {
      ...update,
      open: true,
    });
  }
);

export const hideSnackbarAtom = atom(null, (_, set) => {
  set(snackbarAtom, (prev) => ({ ...prev, open: false }));
});
